'use client';

export const saveResponseAsFile = async (
  response: Response,
  defaultName: string
) => {
  const cd = response.headers.get('Content-Disposition');
  const fileName = cd?.split(';')[1]?.split('=')[1] || defaultName;

  const blob = await response.blob();
  const uri = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = uri;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
